import React from "react";
import { cn } from "~/utils";

const Input = React.forwardRef(function (
  {
    className = "",
    containerClassName = "",
    invalid = false,
    invalidClassName = "",
    label = "",
    labelClassName = "",
    required,
    ...props
  },
  ref,
) {
  const id = `${label ? label.toLowerCase() : "unlabelled"}-input`;
  return (
    <div className={cn("flex flex-col gap-1", containerClassName)}>
      {label && (
        <label
          htmlFor={id}
          className={cn(
            "text-xs text-slate-500",
            labelClassName,
            invalid ? cn("text-red-400", invalidClassName) : "",
          )}
        >
          {label}
          {required && <span className="text-red-500">&nbsp;*</span>}
        </label>
      )}
      <input
        id={id}
        ref={ref}
        className={cn(
          "w-full rounded border !border-gray-200 !p-[7px] text-sm outline-blue-300",
          className,
          invalid ? "!border-red-400 outline-red-400" : "",
        )}
        required={required}
        {...props}
      />
    </div>
  );
});

export default Input;
